const state = {
  /**
   * create-update view specific values
   */
  masterVehiclesList: [],
  masterTransportersList: [],
  isOrderProcessing: false,

  sourceHasEmpty: false,
  sourceList: [],

  // dropoff
  dropsHasEmpty: false,
  dropsList: [],

  /**
   * common values across views
   */
  isLoading: false,
  list: [],
  filter: {},
  hasEmpty: true,

  isLoadingSoldTo: false,
  listSoldTo: [],
  filterSoldTo: {},
  hasEmptySoldTo: true,
  // purchase order, custom materials stored
  indentBootstrap: {},
  isLrMandatoryForMarkAsDelivered: false,
};

export default state;
